import { createAsyncThunk } from "@reduxjs/toolkit";
import Api from "../../BaseUrlConfigration/ApiConfig";

export const createPackAction = createAsyncThunk(
  "pack-create",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.post("/packs/create", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getPackDetailsAction = createAsyncThunk(
  "pack-details",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(`/packs/details/${reqBody?.id}`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getPackNotificationAction = createAsyncThunk(
  "pack-notification",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(`/packs/check-notifications-dot`);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getAllPacksAction = createAsyncThunk(
  "packs-list",
  async (reqBody, thunkAPI) => {
    try {
      const sortBy = reqBody?.sortBy ?? reqBody?.sortKey ?? "";
      const response = await Api.get(
        `/packs/list?search=${
          reqBody?.searchValue == undefined ? "" : reqBody?.searchValue
        }&page=${reqBody.page}&limit=${
          reqBody?.limit == undefined ? "" : reqBody?.limit
        }&sortBy=${sortBy}&sortOrder=${
          reqBody?.sortOrder == undefined ? "" : reqBody?.sortOrder
        }`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getRequestedPacksAction = createAsyncThunk(
  "requested-packs",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.get(
        `/packs/requested-packs?search=${
          reqBody?.searchValue == undefined ? "" : reqBody?.searchValue
        }&page=${reqBody.page}&limit=${
          reqBody?.limit == undefined ? "" : reqBody?.limit
        }`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const getAllVideosAction = createAsyncThunk(
  "video-list",
  async (reqBody, thunkAPI) => {
    console.log({ reqBody });
    try {
      const response = await Api.get(
        `/content/video-list?search=${
          reqBody?.searchValue == undefined ? "" : reqBody?.searchValue
        }&page=${reqBody.page}&limit=${
          reqBody?.limit == undefined ? "" : reqBody?.limit
        }&group=${
          reqBody?.group == undefined ? "" : reqBody?.group
        }&categoryId=${reqBody?.category == undefined ? "" : reqBody?.category}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const updatePackAction = createAsyncThunk(
  "pack-update",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.put("/packs/update", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const updatePackStatusAction = createAsyncThunk(
  "pack-status-update",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.put("/packs/update-pack-status", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const removeSchoolAction = createAsyncThunk(
  "remove-school",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.put("/packs/remove-pack", reqBody);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

export const deletePackAction = createAsyncThunk(
  "pack-delete",
  async (reqBody, thunkAPI) => {
    try {
      const response = await Api.patch(
        `/packs/delete/${reqBody?.id}?check=${reqBody?.check}`,
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);
